export default "__VITE_ASSET__Dp$yqHiN__"